export const ROVER_CACHE_BYPASS_REASON_HEADER = 'x-rover-cache-bypass-reason';
export const ROVER_CACHE_STATUS_HEADER = 'x-html-edge-cache-status';
export const ROVER_WARM_CACHE_HEADER = 'x-warm-html-edge-cache';
export const ROVER_SEARCH_SOURCE_HEADER = 'x-search-source';
export const ROVER_GTM_COOKIES_HEADER = 'x-rover-gtm-cookies';
export const ROVER_UPSTREAM_REDIRECT_HEADER_NAME = 'X-Rover-Upstream-Redirect';
